import React, { useState } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import AppointmentModal from "../Components/AppointmentModal";
import "../Styles/Services.css";

function Services() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="services-page">
      <Navbar />

      {/* Hero Section */}
      <section className="services-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <div className="hero-badge">
            <span>Professional Healthcare Services</span>
          </div>
          <h1 className="hero-title">
            Comprehensive Medical
            <span className="hero-highlight"> Excellence</span>
          </h1>
          <p className="hero-description">
            Discover our complete range of specialized medical services designed to provide
            exceptional care for neurological, endocrine, and rehabilitation needs with
            cutting-edge technology and compassionate expertise.
          </p>
        </div>
        <div className="hero-shape">
          <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <circle cx="50" cy="50" r="40" fill="rgba(255,255,255,0.1)"/>
            <circle cx="50" cy="50" r="25" fill="rgba(255,255,255,0.05)"/>
          </svg>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section">
        <div className="services-container">
          <div className="section-intro">
            <h2 className="section-main-title">Our Specialized Services</h2>
            <p className="section-description">
              We offer comprehensive healthcare solutions across multiple disciplines,
              ensuring every patient receives personalized, expert medical care.
            </p>
          </div>

          <div className="services-grid">
            {/* Neuro Medical Services */}
            <div className="service-card">
              <div className="card-header">
                <div className="card-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9V7L15 1H5C3.89 1 3 1.89 3 3V21C3 22.11 3.89 23 5 23H19C20.11 23 21 22.11 21 21V9M19 9H14V4H19V9M12 11C13.66 11 15 12.34 15 14C15 15.66 13.66 17 12 17C10.34 17 9 15.66 9 14C9 12.34 10.34 11 12 11Z"/>
                  </svg>
                </div>
                <h3 className="card-title">Neuro Medical Services</h3>
                <p className="card-subtitle">Advanced neurological care and treatment</p>
              </div>

              <div className="card-content">
                <div className="services-list">
                  <div className="service-group">
                    <h4 className="group-title">Neurological Conditions</h4>
                    <ul className="service-items">
                      <li><span className="bullet">•</span>Headache & Migraine Management</li>
                      <li><span className="bullet">•</span>Paralysis Treatment</li>
                      <li><span className="bullet">•</span>Seizure Disorders (Epilepsy)</li>
                      <li><span className="bullet">•</span>Peripheral Neuropathy</li>
                      <li><span className="bullet">•</span>Memory Disorders</li>
                      <li><span className="bullet">•</span>Back Pain & Sciatica</li>
                    </ul>
                  </div>

                  <div className="service-group">
                    <h4 className="group-title">Specialized Care</h4>
                    <ul className="service-items">
                      <li><span className="bullet">•</span>Muscle Disorders</li>
                      <li><span className="bullet">•</span>Diabetic Neuropathy</li>
                      <li><span className="bullet">•</span>Parkinson's Disease</li>
                      <li><span className="bullet">•</span>Dementia Care</li>
                      <li><span className="bullet">•</span>Eye Movement Disorders</li>
                      <li><span className="bullet">•</span>Meningitis & Brain Infections</li>
                      <li><span className="bullet">•</span>Ataxia Treatment</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* General Medicine & Endocrine */}
            <div className="service-card">
              <div className="card-header">
                <div className="card-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2M21.5 12.5C21.5 13.33 20.83 14 20 14C19.17 14 18.5 13.33 18.5 12.5C18.5 11.67 19.17 11 20 11C20.83 11 21.5 11.67 21.5 12.5M18.5 18.5C18.5 19.33 17.83 20 17 20C16.17 20 15.5 19.33 15.5 18.5C15.5 17.67 16.17 17 17 17C17.83 17 18.5 17.67 18.5 18.5M15.5 6.5C15.5 7.33 14.83 8 14 8C13.17 8 12.5 7.33 12.5 6.5C12.5 5.67 13.17 5 14 5C14.83 5 15.5 5.67 15.5 6.5Z"/>
                  </svg>
                </div>
                <h3 className="card-title">General Medicine & Endocrine</h3>
                <p className="card-subtitle">Comprehensive internal medicine and hormonal care</p>
              </div>

              <div className="card-content">
                <div className="services-list">
                  <div className="service-group">
                    <h4 className="group-title">Metabolic Disorders</h4>
                    <ul className="service-items">
                      <li><span className="bullet">•</span>Diabetes Management</li>
                      <li><span className="bullet">•</span>Thyroid Disorders</li>
                      <li><span className="bullet">•</span>Hypertension & Cholesterol</li>
                      <li><span className="bullet">•</span>Pituitary Gland Disorders</li>
                    </ul>
                  </div>

                  <div className="service-group">
                    <h4 className="group-title">Women's Health & Pediatrics</h4>
                    <ul className="service-items">
                      <li><span className="bullet">•</span>Gynecological Disorders</li>
                      <li><span className="bullet">•</span>Menopause Management</li>
                      <li><span className="bullet">•</span>Pediatric Endocrine Care</li>
                      <li><span className="bullet">•</span>Growth & Development Issues</li>
                    </ul>
                  </div>

                  <div className="service-group">
                    <h4 className="group-title">Bone & Mineral Health</h4>
                    <ul className="service-items">
                      <li><span className="bullet">•</span>Osteoporosis Treatment</li>
                      <li><span className="bullet">•</span>Vitamin D Deficiency</li>
                      <li><span className="bullet">•</span>Calcium Metabolism Disorders</li>
                      <li><span className="bullet">•</span>Hormone Replacement Therapy</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Physiotherapy & Rehabilitation */}
            <div className="service-card">
              <div className="card-header">
                <div className="card-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9V7L15 1H5C3.89 1 3 1.89 3 3V21C3 22.11 3.89 23 5 23H19C20.11 23 21 22.11 21 21V9M19 9H14V4H19V9M7 15C7 13.34 8.34 12 10 12S13 13.34 13 15 11.66 18 10 18 7 16.66 7 15M17 15C17 16.66 15.66 18 14 18S11 16.66 11 15 12.34 12 14 12 17 13.34 17 15Z"/>
                  </svg>
                </div>
                <h3 className="card-title">Physiotherapy & Rehabilitation</h3>
                <p className="card-subtitle">Advanced rehabilitation and physical therapy</p>
              </div>

              <div className="card-content">
                <div className="services-list">
                  <div className="service-group">
                    <h4 className="group-title">Post-Surgical Rehabilitation</h4>
                    <ul className="service-items">
                      <li><span className="bullet">•</span>Orthopedic Surgery Recovery</li>
                      <li><span className="bullet">•</span>Joint Replacement Rehabilitation</li>
                      <li><span className="bullet">•</span>Sports Injury Recovery</li>
                    </ul>
                  </div>

                  <div className="service-group">
                    <h4 className="group-title">Pain Management</h4>
                    <ul className="service-items">
                      <li><span className="bullet">•</span>Chronic Pain Treatment</li>
                      <li><span className="bullet">•</span>Shoulder & Knee Pain</li>
                      <li><span className="bullet">•</span>Temporomandibular Disorders</li>
                    </ul>
                  </div>

                  <div className="service-group">
                    <h4 className="group-title">Specialized Therapy</h4>
                    <ul className="service-items">
                      <li><span className="bullet">•</span>Cerebral Palsy Management</li>
                      <li><span className="bullet">•</span>Neurological Rehabilitation</li>
                      <li><span className="bullet">•</span>Geriatric Physical Therapy</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-container">
          <h2 className="cta-title">Ready to Experience Exceptional Care?</h2>
          <p className="cta-description">
            Schedule your consultation today and take the first step towards better health
            with our expert medical team.
          </p>
          <div className="cta-buttons">
            <button onClick={openModal} className="cta-primary-btn">
              Book Appointment
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6L16 12 10 18 8.59 16.59Z"/>
              </svg>
            </button>
            <a href="#contact" className="cta-secondary-btn">
              Contact Us
            </a>
          </div>
        </div>
      </section>

      <Footer />

      <AppointmentModal isOpen={isModalOpen} onClose={closeModal} />
    </div>
  );
}

export default Services;
